import styled from "styled-components"
import media from "styled-media-query"

export const AccordionWrapper = styled.div`
  // margin-top: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-radius: 10px;
  height: auto;
  padding: 2%;
  text-align: center;
  ${media.lessThan("small")`
        text-align: left;
    `}
  div {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    h4 {
      font-family: Josefin Sans;
      font-style: normal;
      font-weight: 600;
      font-size: 25px;
      line-height: 30px;
      ${media.lessThan("small")`
                font-size: 18px;
                margin-bottom: 20px;
            `}
    }
    span {
      float: right;
      transform: rotate(0deg);
      overflow: hidden;
      transition: all 0.3s ease-out;
      transform: ${props => (props.open ? `rotate(-180deg)` : "")};
    }
  }
`

export const InternalWrapper = styled.div`
  width: 100%;
  max-height: ${props => (props.open ? "400px" : "0")};
  transition: all 0.4s ease-in-out;
  overflow: hidden;
  p {
    font-family: Josefin Sans;
    font-style: normal;
    font-weight: 300;
    font-size: 20px;
    line-height: 25px;
    text-align: left;
    color: #707070;
    ${media.lessThan("small")`
            font-size: 16px;
            line-height: 30px;
        `}
  }
`
